import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/category/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/category/create', data)
}
export function updateStatus (data) {
  return request.post('/business/category/updateStatus', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/category/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/category/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/category/delete/batch', {
    params: {
      ids
    }
  })
}
